import { Component, EventEmitter, Input, Output, OnChanges, SimpleChanges, ChangeDetectorRef } from '@angular/core';
// Remove CDK Drag and Drop imports if they are no longer used by other features in this component
// import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';


@Component({
  selector: 'app-edit-tests-modal',
  templateUrl: './edit-tests-modal.component.html',
  styleUrls: ['./edit-tests-modal.component.scss']
})
export class EditTestsModalComponent implements OnChanges {
  @Input() isVisible: boolean = false;
  @Input() testsToEdit: any[] = []; // These are the test data objects
  @Input() columnsForModal: string[] = []; // Columns to display and edit
  @Input() microScenarioIdForContext: string = ''; // For context if needed

  @Output() saveTests = new EventEmitter<any[]>();
  @Output() closeModal = new EventEmitter<void>();

  // Local copy for editing within the modal
  editableModalTests: any[] = [];
  private nextTempId = -1; // For temporary unique IDs for new rows in the modal

  constructor(private cd: ChangeDetectorRef) {} // Inject ChangeDetectorRef

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['testsToEdit'] && this.testsToEdit) {
      // Deep copy to prevent direct modification of parent's data
      // And assign a temporary ID for trackBy if items don't have a reliable one
      this.editableModalTests = JSON.parse(JSON.stringify(this.testsToEdit)).map(test => ({
        ...test,
        _modalInternalId: test._frontendDisplayId_ || `new_in_modal_${this.nextTempId--}`
      }));
    }
  }

  addNewTest(): void {
    const newTest: any = {
      _modalInternalId: `new_in_modal_${this.nextTempId--}`,
      _frontendDisplayId_: undefined, // Mark as a completely new test
      // Initialize other properties based on columnsForModal
    };
    this.columnsForModal.forEach(col => {
      if (col.toLowerCase() !== 'id' && !col.startsWith('_')) { // Don't pre-fill our special IDs
        newTest[col] = ''; // Or some default value
      }
    });
    this.editableModalTests.push(newTest);
    this.editableModalTests = [...this.editableModalTests]; // Create a new array reference
    this.cd.detectChanges(); // Explicitly detect changes after adding a new row
  }

  removeTest(index: number): void {
    this.editableModalTests.splice(index, 1);
    this.editableModalTests = [...this.editableModalTests]; // Create a new array reference
    this.cd.detectChanges(); // Explicitly detect changes after removing a row
  }

  moveTestUp(index: number): void {
    if (index > 0) {
      [this.editableModalTests[index], this.editableModalTests[index - 1]] = [this.editableModalTests[index - 1], this.editableModalTests[index]];
      this.editableModalTests = [...this.editableModalTests];
      this.cd.detectChanges();
    }
  }

  moveTestDown(index: number): void {
    if (index < this.editableModalTests.length - 1) {
      [this.editableModalTests[index], this.editableModalTests[index + 1]] = [this.editableModalTests[index + 1], this.editableModalTests[index]];
      this.editableModalTests = [...this.editableModalTests];
      this.cd.detectChanges();
    }
  }

  onSave(): void {
    // Before emitting, remove the _modalInternalId
    const testsToReturn = this.editableModalTests.map(test => {
      const { _modalInternalId, ...rest } = test;
      return rest; // Contains original _frontendDisplayId_ for existing, or undefined for new
    });
    this.saveTests.emit(JSON.parse(JSON.stringify(testsToReturn)));
  }

  onCancel(): void {
    this.closeModal.emit();
  }

  // For *ngFor in the modal's table
  trackByModalTest(index: number, test: any): string {
    return test._modalInternalId || index.toString(); // Corrected trackBy property
  }
}